export default {
  ACCEPTED: 'accepted',
  ACTION_REQUIRED: 'action_required',
  CREDIT_NOTE_PENDING: 'credit_note_pending',
  DECLINED: 'declined',
  IN_PROGRESS: 'in_progress',
  SUBMITTED: 'submitted',
  SUCCESSFUL: 'successful',
};
